<template>
  <div class="app-sticky-cart" @click="scrollToCart()" aria-hidden="true">
    <div class="sticky-cart--left">
      <div class="cart-icon">
        <img src="files/flash/images/svg-icons/cart.svg" alt="">
      </div>
      <div class="down-icon">
        <img src="files/flash/images/svg-icons/arrowd-yellow.svg" alt="">
      </div>
    </div>
    <div class="sticky-cart--right">
      <div class="price">
        <slot name="priceSection"/>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'StickyCart',
  props: {
    fee: {
      type: Number,
      default: 0
    }
  },
  methods: {
    scrollToCart () {
      const targetElement = document.getElementById('cart-sidebar')
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    }
  }
}
</script>
